import React, { useState } from "react";
import { PublicShell, BackButton } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks! We'll be in touch at " + form.email);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <PublicShell>
      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
        <BackButton to="/" label="Back to home" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Contact us</p>
            <h1 className="font-display mt-3 text-4xl sm:text-5xl tracking-tight font-bold text-[#0A2540]">We're here to help.</h1>
            <p className="mt-5 text-[#333333] max-w-md">
              Reach the FlexiVouch team for merchant onboarding, integration questions, or support.
            </p>
            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-3"><Phone size={18} className="text-[#00C4B4] mt-1" /><div><p className="text-sm text-[#666666]">Phone</p><p className="text-[#0A2540] font-semibold" data-testid="contact-phone">079 485 2928</p></div></div>
              <div className="flex items-start gap-3"><Mail size={18} className="text-[#00C4B4] mt-1" /><div><p className="text-sm text-[#666666]">Email</p><p className="text-[#0A2540] font-semibold" data-testid="contact-email">info@praxio.co.za</p></div></div>
              <div className="flex items-start gap-3"><MapPin size={18} className="text-[#00C4B4] mt-1" /><div><p className="text-sm text-[#666666]">Address</p><p className="text-[#0A2540] font-semibold" data-testid="contact-address">31 5th Street, Commercia, Midrand, 1685</p></div></div>
            </div>
          </div>
          <form onSubmit={submit} data-testid="contact-form" className="bg-white border border-[#E5E7EB] rounded-2xl p-7 space-y-4">
            <div className="space-y-2"><Label htmlFor="name">Your name</Label><Input data-testid="contact-name-input" id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div className="space-y-2"><Label htmlFor="email">Email</Label><Input data-testid="contact-email-input" id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div className="space-y-2"><Label htmlFor="msg">Message</Label><Textarea data-testid="contact-message-input" id="msg" rows={5} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} /></div>
            <Button data-testid="contact-submit-btn" type="submit" className="w-full bg-[#0A2540] hover:bg-[#133D6B] text-white">Send message</Button>
          </form>
        </div>
      </section>
    </PublicShell>
  );
}
